<template>
  <!--登录-->
  <div class="login_SignIn">
    <div class="wrap">
      <!--header start-->
      <div class="header login-header">
        <a href="javascript:void(0);" @click="fn" class="icon-back"></a>
        <!--<router-link class="icon-back" to="/home"></router-link>-->央视账号登录
      </div>

      <div class="line-gray"></div>
      <!--header end-->

      <!--content start-->
      <div class="content login-content">
        <form class="lg-tabbox" id="punishformID">
          <div class="group-item">
            <label><i class="icon-lg-accout"></i></label>
            <div class="input-box input-tel">
              <input type="text" placeholder="请输入邮箱或手机" name="username" id="username" v-model="userName"/>
              <div class="btn-del" style="display: none" v-show="userName!= ''" @click="userName = ''">
              </div>
            </div>
          </div>
          <p class="text-danger uname" style="display: none">输入格式有误，请使用邮箱或手机号登录</p>
          <div class="group-item">
            <label><i class="icon-lg-password"></i></label>
            <div class="input-box input-tel">
              <input type="password" placeholder="请输入密码" name="password" id="password" v-model="password"/>
              <div class="btn-del" style="display: none" v-show="password!= ''" @click="password = ''">
              </div>
            </div>
          </div>
          <p class="text-danger upass" style="display: none">密码错误，请重输。</p>
          <div class="group-info">
            <a href="javascript:void(0);" class="font-lgr">登&nbsp;&nbsp;录</a>
          </div>
          <div class="group-mess">
            <router-link to="/repassword" tag="a">
              忘记密码
            </router-link>
            <router-link to="/quick" tag="a">
              无账号手机登录
            </router-link>
            <!--    <a href="javascript:void(0);">

                </a>
                <a href="javascript:void(0);">
                  无账号手机登录
                </a>-->
          </div>
        </form>
      </div>
      <!--content end-->

      <!--other start-->
      <div class="login-other" v-if="thirdParty">
        <p class="lg-tit">第三方登录</p>
        <!--http://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=http://d.site.ishow.cctv.com-->
        <a
          href="https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=https://act.ishow.cctv.com/h5/mymessage">
          <img src="../../../static/dist/img/icon-qq.png">
        </a>
        <a
          href="https://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=https://act.ishow.cctv.com/h5/mymessage">
          <img src="../../../static/dist/img/icon-blog.png">
        </a>
        <a
          href="https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=https://act.ishow.cctv.com/h5/mymessage">
          <img src="../../../static/dist/img/icon-zfb.png">
        </a>
      </div>
      <!--other end-->

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userName: '',  //userN
        password: '',   //password
        //thirdParty: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1? false : true,
        thirdParty:true
      }
    },
    methods: {
      //操作按钮事件
      fn() {
        if (window.history.length <= 1) {
          this.$router.push({name: 'home'});
        } else {
          this.$router.back(-1)
        }
      }
    },
    mounted: function () {
      // var form=$document.forms['eg']；
      var that = this;
      // 判断是否是小程序
      function ready() {
        if(window.__wxjs_environment === 'miniprogram'){
          that.thirdParty = false;
        }
      }
      if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
        document.addEventListener('WeixinJSBridgeReady', ready, false)
      } else {
        ready()
      }
      //操作DOM
      $('.group-info').on('click', 'a', function () {
        if (document.getElementById('username').value == '') {
          //document.getElementById('username').style.display='';
          $('.uname').css('display', 'block');
          return;
        } else {
          $('.uname').css('display', 'none');
        }
        if (document.getElementById('password').value == '') {
          $('.upass').css('display', 'block');
          return;
        } else {
          $('.upass').css('display', 'none');
        }

        document.getElementById('punishformID')['from'] = '';

        passport.checkJsonpForm(document.getElementById('punishformID'), function (result) {
          var msg = result.msg;//提示信息
          var errorCode = result.errorCode;//错误码，i18n展示用
          if (passport.usernameError == result.type) {//如果是用户名有问题
            //alert(msg)
            $('.upass').css('display', 'block');

            $('#password').val('');
            //在用户名的位置展示错误提示信息
          } else if (passport.passwordError == result.type) {//如果是密码有问题
            //alert(msg)
            $('.uname').css('display', 'block');
            $('#password').val('');
            //在密码的位置展示错误提示信息
          } else if (passport.success == result.type) {//登录成功

            //处理用户id：result.usrid 或者 result.user_seq_id
            // that.setCookie('userSeqId', result.user_seq_id);//打包时要注释
            // that.$router.push({name: 'home'});
            that.$router.push({name: 'MyMessage'})
          }

        });
      });

    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login/signIn.vue